// postService.jsに投稿削除関数を追加
import { getFirestore, doc, deleteDoc } from 'firebase/firestore';
import { getFirebaseApp } from './firebaseConfig';

const db = getFirestore(getFirebaseApp());

export async function deletePostFromFirestore(postId) {
  if (!postId) return;
  await deleteDoc(doc(db, 'posts', postId));
}
